module.exports = __webpack_public_path__ + "img/twitter.07fa6a17.png";